import {createContext} from 'react';

const ReactContext = createContext({
    formFields:{},
    changeHandler: () => {},
});

export default ReactContext;